// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3CE96","inputWrap":"styles_inputWrap__27G9_","input":"styles_input__nkF8w"};